import React, { Component } from 'react';
import { makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import qs from 'qs';

import { chatStore } from '../../../../store/FrontChatStore';
import { navigate } from '../../../../helper/HistoryHelper';

import { COMPANY } from '../../../../const/company';
import Favicon from '../../../../assets/company/qv-favicon.svg';
import Logo from '../../../../assets/company/qv-loading.png';
import {
  fetchClosedMessage,
  buildRestartUrl,
} from '../../../../helper/consultActions';

import Styles from './QvCloseView.module.scss';

@observer
class QvCloseView extends Component {
  constructor(props) {
    super(props);
    makeObservable(this);
    let queryParam = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    let isRating = queryParam.isRating;
    fetchClosedMessage(isRating === 'true').then((message) => {
      this.message = message;
    });
  }

  @observable
  message = '챗봇 상담을 종료했습니다.';

  render() {
    return (
      <div className={Styles.Container}>
        <div className={Styles.HeaderContainer}>
          <div className={Styles.HeaderGradientBar} />
          <div className={Styles.Header}>
            <img
              src={Favicon}
              alt={COMPANY.QV.name}
              className={Styles.LogoMini}
            />
            <span className={Styles.BrandName}>
              {COMPANY.QV.name} 상담봇
            </span>
          </div>
        </div>
        <div className={Styles.CloseContent}>
          <div className={Styles.CloseBody}>
            <div className={Styles.Character}>
              <img
                src={Logo}
                alt={COMPANY.QV.name}
                style={{
                  width: '200px',
                  height: '200px',
                  objectFit: 'cover',
                  borderRadius: '50%',
                  backgroundColor: 'transparent',
                }}
              />
            </div>
            <div className={Styles.LabelWrap}>
              <div className={Styles.Title}>{this.message}</div>
              <ul className={Styles.Label}>
                <li>
                  <p>
                    일정시간 입력이 없는 경우, 개인 정보 보호를 위해 챗봇과
                    상담을 종료합니다.
                  </p>
                </li>
                <li>
                  <p>채팅 상담을 원하시면, 상담 재시작 버튼을 선택해 주세요.</p>
                </li>
              </ul>
            </div>
          </div>
          <button
            className={Styles.RestartButton}
            onClick={() => {
              chatStore.setChannel(undefined);
              navigate(
                buildRestartUrl(),
              );
            }}
          >
            상담 재시작
          </button>
        </div>
      </div>
    );
  }
}

export default QvCloseView;
